/**
 * Workspace: file tree, workspace home, report viewer, opening workspace links.
 * Keys must match ../en/workspace.ts.
 *
 * Not here on purpose: homepage content (titles, questions, cards) comes from the
 * admin-edited config, and DEFAULT_HOMEPAGE_CONFIG is that content's fallback.
 * Bilingual homepage content is a separate item.
 */
const workspace = {
  nav: {
    label: '工作区导航',
    title: '工作区',
    resize: '拖动调整宽度，双击恢复默认',
    collapse: '收起',
    collapseLabel: '收起工作区面板',
    search: '搜索',
    searchLabel: '搜索工作区',
    recent: '最近打开',
    loading: '正在加载工作区…',
    loadFailed: '加载工作区失败',
    empty: '工作区还没有文件',
    emptyFolder: '没有文件',
    noMatches: '没有匹配的文件',
  },
  home: {
    busy1: '☕ Rocky 正在思考中，喝口茶稍等一下~',
    busy2: '🧠 Rocky 还在忙，让它先回完再说~',
    busy3: '⏳ 等 Rocky 回复完再点，别急~',
    busy4: '🍵 Rocky 专注中，稍后再来~',
    readOnly: '👀 当前为 Admin 查看模式，无法操作',
    queueFull: '待发送队列最多 3 条',
    promptsLink: 'Rocky按情景Prompt合集 · 复制就能用',
    guideLink: 'CMHK AI Agents 选用指南',
    badgeNew: '新',
    badgeHot: '热门',
  },
  viewer: {
    loading: '正在加载报告…',
    loadImageFailed: '加载图片失败',
    loadReportFailed: '加载报告失败',
    cannotPreview: '该文件类型暂不支持预览',
    download: '下载',
    downloading: '下载中…',
    downloadTitle: '下载报告',
    downloadFailed: '下载失败，请重试。',
    csvTruncated: '显示前 {{shown}} 行，共 {{total}} 行 — 其余请下载查看',
    csvTotal: '共 {{total}} 行',
  },
  openFile: {
    noAccess: '无法在 Rocky 工作区打开该文件：当前账号不在 {{groups}} LDAP 组中。\n\n请通过以下链接申请访问权限：\n{{url}}',
  },
};

export default workspace;
